import { useEffect, useState } from "react";
import useApi from "./useApi";

interface SquareStatus {
  configured: boolean;
  displayName?: string;
  merchantName?: string;
  locationName?: string;
}

export default function useSquareStatus() {
  const [status, setStatus] = useState<SquareStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const api = useApi();

  useEffect(() => {
    async function fetch() {
      setLoading(true);
      try {
        const resp = await api.admin.get("Square/Status");
        setStatus(await resp.json());
      } catch {
        setStatus({ configured: false });
      } finally {
        setLoading(false);
      }
    }
    fetch();
  }, [api.admin]);

  return { status, loading };
}
